export default "__VITE_ASSET__713bc0b6__"